import React from "react";
import label from "../../labels/postExaminationProcessObjective_en.json";

const PreExamReport = () => {
  return (
    <div className="dashboardContentArea">
      <h5> {label.PreExamReport} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default PreExamReport;
